"use client";

import { MapPinIcon } from "@heroicons/react/20/solid";
import { useHydrated } from "@utils/hooks";
import Link from "next/link";

interface Props {
  address: {
    line1: string;
    line2: string;
    line3: string;
    city: string;
    country: string;
    countrycode: string;
    lat: string;
    long: string;
  };
}

export default function VenueMapLink({ address }: Props) {
  const hydrated = useHydrated();
  const isIOS = hydrated ? navigator.userAgent.includes("like Mac") : false;

  return (
    <Link
      href={`${
        isIOS ? "maps" : "https"
      }://maps.google.com/maps/search/?api=1&query=${address.lat}%2C${
        address.long
      }`}
      className="flex items-center gap-1 p-1 text-sm leading-6 font-medium rounded-lg bg-indigo-100 text-indigo-800 hover:bg-indigo-500 hover:text-white transition-colors ease-in-out duration-200"
    >
      <MapPinIcon className="w-5 h-5" />
      <span>
        {[address.line1, address.line2, address.line3]
          .filter((line) => line)
          .join(", ")}
      </span>
    </Link>
  );
}
